import './App.css';
import './styles/platform-theme.css';
import BootstrapNavbar from './Components/BootstrapNavbar'
import Login from './routes/login';
import About from './routes/about';
import CreateUser from './routes/createUser';
import Verify from './routes/verify';
import AuthVerify from './routes/authVerify';
import UserList from './routes/userList';
import EditUser from './routes/editUser';
import Course from './routes/course';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useState } from 'react';
import ScrollToTop from './Components/ScrollToTop';
import ErrorReporter from './routes/ErrorReporter';
import ErrorReportButton from './Components/ErrorReportButton';
import ResetPassword from './routes/resetPassword';
import RequestReset from './routes/requestReset';
import Stats from './routes/stats';
import FooterGate from './Components/FooterGate';
import { ApplicationProvider } from './context/ApplicationContext';
import EventsList from './routes/eventsList';
import CreateEvent from './routes/createEvent';
import ModifyEvent from './routes/modifyEvent';
import EventView from './routes/eventView';
import DashboardRoutes from './routes/dashboard';
import PlatformHome from './routes/platformHome';
import Ottieni from './routes/ottieni';
import { extractAppSlugFromPath, rememberAppSlug, resolveAppSlug } from './utils/appSlug';
import { getStoredLoginStatus } from './utils/session';

function AppContent({ loginStatus, setLoginStatus }) {
  const location = useLocation();
  const appSlug = resolveAppSlug(location.pathname, loginStatus);
  const pathSlug = extractAppSlugFromPath(location.pathname);

  if (pathSlug) {
    rememberAppSlug(pathSlug);
  } else if (loginStatus?.application_slug) {
    rememberAppSlug(loginStatus.application_slug);
  }

  return (
    <ApplicationProvider slug={appSlug}>
      <ScrollToTop />
      <div className="app-shell">
        <ErrorReportButton />
        <BootstrapNavbar loginStatus={loginStatus} setLoginStatus={setLoginStatus} />
        <main className="app-main">
          <Switch>
            <Route exact path="/" render={() => <PlatformHome loginStatus={loginStatus} />} />
            <Route exact path="/ottieni" component={Ottieni} />
            <Route exact path="/about"><Redirect to="/" /></Route>
            <Route path="/dashboard" render={() => <DashboardRoutes loginStatus={loginStatus} setLoginStatus={setLoginStatus} />} />
            <Route exact path="/login" render={() => <Login loginStatus={loginStatus} setLoginStatus={setLoginStatus} />} />
            <Route path="/register"><Redirect to="/login" /></Route>
            <Route path="/verify" component={Verify} />
            <Route path="/users/:id/edit" component={EditUser} />
            <Route path="/users" component={UserList} />
            <Route path="/error" component={ErrorReporter} />
            <Route path="/resetpassword" component={ResetPassword} />
            <Route path="/requestreset"><Redirect to="/login" /></Route>
            <Route path="/stats" component={Stats} />
            <Route path="/events" exact component={EventsList} />
            <Route path="/events/new" component={CreateEvent} />
            <Route path="/events/:id/edit" component={ModifyEvent} />
            <Route path="/events/:id/view" component={EventView} />
            <Route path="/:appSlug/course/:id" render={(props) => <Course loginStatus={loginStatus} appSlug={props.match.params.appSlug} />} />
            <Route path="/:appSlug/verify" render={(props) => <Verify appSlug={props.match.params.appSlug} />} />
            <Route path="/:appSlug/login" render={(props) => <Login loginStatus={loginStatus} setLoginStatus={setLoginStatus} appSlug={props.match.params.appSlug} />} />
            <Route path="/:appSlug/register" render={(props) => <CreateUser appSlug={props.match.params.appSlug} />} />
            <Route path="/:appSlug/requestreset" render={(props) => <RequestReset appSlug={props.match.params.appSlug} />} />
            <Route path="/:appSlug" exact render={(props) => <About loginStatus={loginStatus} appSlug={props.match.params.appSlug} />} />
          </Switch>
        </main>
        <AuthVerify setLoginStatus={setLoginStatus} loginStatus={loginStatus} />
        <FooterGate />
      </div>
    </ApplicationProvider>
  );
}

function App() {
  const [loginStatus, setLoginStatus] = useState(getStoredLoginStatus);
  return (
    <div className='content'>
      <Router>
        <AppContent loginStatus={loginStatus} setLoginStatus={setLoginStatus} />
      </Router>
    </div>
  );
}

export default App;
